// Dates as yyyy-mm-dd keys in local time, the way every page groups them.

const pad = (n: number) => String(n).padStart(2, '0');

export function dayKey(v: Date | string | number | null | undefined): string {
  if (v === null || v === undefined || v === '') return '';
  const d = v instanceof Date ? v : new Date(v);
  if (isNaN(d.getTime())) return '';
  return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
}

export function todayKey(): string {
  return dayKey(new Date());
}

export function tomorrowKey(): string {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  return dayKey(d);
}

/** Milliseconds of a date string, 0 when missing or unreadable. */
export function tsOf(v: string | null | undefined): number {
  const t = v ? new Date(v).getTime() : NaN;
  return isNaN(t) ? 0 : t;
}

export function addDays(key: string, n: number): string {
  const d = new Date(key + 'T12:00:00');
  d.setDate(d.getDate() + n);
  return dayKey(d);
}

export function daysBetween(a: string, b: string): number {
  return Math.round((new Date(b + 'T12:00:00').getTime() - new Date(a + 'T12:00:00').getTime()) / 864e5);
}

export function monthKey(v: string | null | undefined): string {
  const k = dayKey(v);
  return k ? k.slice(0, 7) : '';
}

/** Days since 1899-12-30, the way Excel stores a date. */
export function excelSerial(dayKeyValue: string): number {
  const p = dayKeyValue.split('-');
  return Math.round((Date.UTC(+p[0], +p[1] - 1, +p[2]) - Date.UTC(1899, 11, 30)) / 86400000);
}

/** An Excel serial or a dd/mm/yyyy text back to a day key. */
export function serialToKey(v: unknown): string | null {
  if (typeof v === 'number' && v > 20000 && v < 80000) {
    return dayKey(new Date(Date.UTC(1899, 11, 30) + v * 864e5 + 12 * 3600e3));
  }
  const m = /(\d{1,2})[/.-](\d{1,2})[/.-](\d{4})/.exec(String(v ?? ''));
  return m ? m[3] + '-' + m[2].padStart(2, '0') + '-' + m[1].padStart(2, '0') : null;
}

/** dd/mm/yyyy, as the Program builder shows dates. */
export function fmtDay(v: string | null | undefined): string {
  if (!v) return '—';
  const d = new Date(v);
  if (isNaN(d.getTime())) return '—';
  return pad(d.getDate()) + '/' + pad(d.getMonth() + 1) + '/' + d.getFullYear();
}
